import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export const ConfirmDialog = ({ open, onOpenChange, title, description, confirmText = "Confirm", cancelText = "Cancel", onConfirm, danger = false, loading = false }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>{title}</DialogTitle>
        <DialogDescription>{description || "Please confirm to continue."}</DialogDescription>
      </DialogHeader>
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="confirm-cancel">{cancelText}</Button>
        <Button onClick={onConfirm} disabled={loading} className={danger ? "bg-rose-600 hover:bg-rose-700 text-white" : "bg-navy-700 hover:bg-navy-800 text-white"} data-testid="confirm-ok">{loading ? "..." : confirmText}</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
